import { STATE_WELCOME } from '../constants/StateConstants';

export default class StateController {
  constructor(game) {
    this.game = game;

    this.transitionToState = false;
    this.transitionToParams = false;

    this.onTransitionComplete = new Phaser.Signal();
  }

  clearCurrentState() {
    this.game.state.clearCurrentState();
  }

  onTransitionInComplete() {
    this.switchStates();
  }

  isWelcomeScreen() {
    return this.game.state.current === STATE_WELCOME;
  }

  switchStates() {
    this.game.state.start(this.transitionToState, ...this.transitionToParams);
    this.game.state.onStateChange.addOnce(this.handleStateChanged, this);
  }

  handleStateChanged() {
    this.onTransitionControllerComplete();
  }

  onTransitionControllerComplete() {
    this.onTransitionComplete.dispatch();
    this.transitionController = null;
  }

  startState({ nextState, nextStateParams }) {
    // where are we going?
    this.transitionToState = nextState;
    this.transitionToParams = nextStateParams;

    this.switchStates();
  }
}
